import { Component, OnInit } from '@angular/core';
import { VersionStore } from './service/version.store';
import { LogService } from '../log/log.service';

@Component({
  selector: 'pioneer-version',
  templateUrl: './version.component.html'
})
export class VersionComponent implements OnInit {

  frontendVersionObj: Object = {};
  backendVersionObj: Object = {};

  constructor(private versionStore: VersionStore,
              private logService: LogService) {
  }

  ngOnInit() {
    this.versionStore.getFrontendVersion().subscribe(versionObj => {
      this.frontendVersionObj = versionObj;
    });
    this.versionStore.getBackendVersion().subscribe(versionObj => {
      this.backendVersionObj = versionObj;
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/version/version.component.ts